import React, { Component } from 'react';
import axios from 'axios';
import { Col, Row } from "reactstrap";
import { toast } from 'react-toastify';
import * as constant from '../../utils/constants';
import {confirmAlert} from "react-confirm-alert";
import './forgetpassword.css';

const platoLogo = require("./../../images/landingPage/platoLogo.png");
const frontlineLogo = require("./../../images/landingPage/platoLogo.png");
const str = "harbingergroup.com";

class ForgetPasswordpage extends Component {

    constructor(props) {
        super(props);
        this.state = { username: "" };
    }

    validate = (username) => {
        const regexp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (username.length > 0 && regexp.test(username)) {
            return true;
        }
        return false;
    }
    
    handleRequest = async () => {
        const { history } = this.props
        let username;
        username = document.getElementById('username').value.toLowerCase();
        const status = this.validate(username);
        if (status === true) {
            axios.post(process.env.REACT_APP_API_URL + '/resetPassword', { username: username },
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
                .then(res => {
                    
                    if (res.data.data.success === false) {
                        
                        document.getElementById("error").innerHTML = "<font color='red'><b><center>" + "This email address is not registered with Harbinger!" + "</center></b></font>"
                    } else {
                        
                        confirmAlert({
                            message: <span style={{display: "flex", textAlign: "center", justifyContent: "center"}}>Password reset link has been sent to your email address!</span>,
                            buttons: [
                                {
                                    label: 'Ok',
                                    onClick: () => {
                                        history.push('/');
                                    }
                                }
                            ]
                        });
                       
                    }
                }).catch(error => {
                    document.getElementById("error").innerHTML = "<font color='red'><b><center>" + error.errors.message + "</center></b></font>"
                });
        }
        else {
            document.getElementById("error").innerHTML = "<font color='red'><b><center>" + "Email is invalid" + "</center></b></font>"
        }
    }

    handleChange = (e) => {
        this.setState({
            username: e.target.value
        });
        if(!e.target.value.includes("harbingergroup.com") || e.target.value.trim() === "") {
            document.getElementById("error").innerHTML = ""
        }
    }

    handleDisable = () => {
        if (this.state.username.split('@')[1] === str) {
           
            document.getElementById("error").innerHTML = "<font color='red'><b><center>" + "This feature is not for Harbinger users!" + "</center></b></font>"
            if (this.state.username.search(str) === -1) {
                return !this.state.username.search(str);
            } else {
                return this.state.username.search(str)
            }
        }
    }

    handleDisable1 = () => {
        return this.state.username ? true: false;
    }

    render() {
        return (
            <div className="app">
                <div className='container login-container'>
                    <div className='login-header'>
                        <img className='login-image' src={frontlineLogo}
                            alt='plato Logo'></img>
                    </div>
                    <div className="FormFields mt-3 login-form">
                        <Row>
                            <Col lg={12}>
                                <Row className="custom-align">
                                    <Col lg={7} xs={10}>
                                        <div className="input-wrapper">
                                            <i className="icon-user icon"></i>
                                            <span className="icon-seperator"></span>
                                            <input type='text' id='username' placeholder='Email'
                                                onChange={this.handleChange} />
                                        </div>
                                    </Col>
                                </Row>
                                <div>
                                    <p id="error" color="danger"></p>
                                </div>
                                <Row className="custom-align">
                                    <Col lg={7} xs={10}>
                                        <button id="forgot_password" className='login-button' disabled={this.handleDisable()} onClick={this.handleRequest}>Reset Password</button>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
        );
    }
}

export default ForgetPasswordpage;